import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { isNullOrUndefined } from 'util';
import { BCMCLPUser, TeamCodes } from '../../../models/clpuser.model';
import { CMClub, CMClubResponse, CMSite, CMSiteListResponse } from '../../../models/cm-club-service.model';
import { DropDownItem, IntDropDownItem, SimpleResponse } from '../../../models/generic-response.model';
import { Membership, MemContactListDropDown, MemPause, REF_MemHardshipReason, REF_MemIndefiniteReason, REF_MemPauseType } from '../../../models/membership.model';
import { CMClubService } from '../../../services/cm-club.service';
import { MembershipService } from '../../../services/membership.service';
import { GlobalService } from '../../../services/shared/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { TeamOfficeService } from '../../../services/team-office.service';
import { UserService } from '../../../services/user.service';

@Component({
    selector: 'app-mem-pause',
    templateUrl: './mem-pause.component.html',
    styleUrls: ['./mem-pause.component.css']
})
/** mem-pause component*/
export class MemPauseComponent {
    memPauseForm: FormGroup;
    teamSub: Subscription;
    curTeam: TeamCodes = <TeamCodes>{};
    showSpinner: boolean;
    clubConfig: CMClub;
    sites: CMSite[];
    encryptedUser: string;
    user: BCMCLPUser;
    ref_MemPauseType_List: REF_MemPauseType[];
    ref_MemHardshipReason_List: REF_MemHardshipReason[];
    ref_MemIndefiniteReason_List: REF_MemIndefiniteReason[];
    memPause: MemPause;
    pauseID: number = 0;
    memContact_dd: MemContactListDropDown[];
    memberShip: Membership;
    contactId: number;
    private destroy$ = new Subject<void>();

    constructor(
        private localService: LocalService,
        private membershipService: MembershipService,
        private _globalService: GlobalService,
        private _router: Router,
        private _route: ActivatedRoute,
        private _utilityService: UtilityService,
        private _teamOfficeService: TeamOfficeService,
        private userService: UserService,
        private fb: FormBuilder,
        private clubService: CMClubService,
        private datePipe: DatePipe
    ) {
        this.localService.setShowMenu(true);
        this.localService.setIsContract(false);
        this.localService.setIsMembership(true);
        this.localService.setRouteName("mem-pause");
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngAfterViewInit() {
        this.encryptedUser = localStorage.getItem("token");
        if (this.encryptedUser) {
            this.authenticateR().then(() => {
                if (this.user) {
                    this.loadData();
                    this.pauseID = this._route.snapshot.queryParams.pauseID ? this._route.snapshot.queryParams.pauseID : 0;
                    this.contactId = this._route.snapshot.queryParams.contactId ? +this._route.snapshot.queryParams.contactId : 0;
                    if (this.pauseID > 0 || this.contactId > 0) {
                        this.memPause_Get();
                    }
                }
                else {
                    this._router.navigate(['/unauthorized']);
                }
            });
        }
        else {
            this._router.navigate(['/unauthorized']);
        }
    }

    async loadData() {
        this.teamSub = this._teamOfficeService.curTeam.pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
            if (data != 0 && data != null) {
                this.curTeam = data
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    await this.memContactDDget();
                    this.ref_MemPauseType_List = this.localService.refMem_GetAllResponse.ref_MemPauseType_List;
                    this.ref_MemHardshipReason_List = this.localService.refMem_GetAllResponse.ref_MemHardshipReason_List;
                    this.ref_MemIndefiniteReason_List = this.localService.refMem_GetAllResponse.ref_MemIndefiniteReason_List;
                }
            }
            else {
                this.curTeam = JSON.parse(localStorage.getItem("curTeam") || "{}")
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    await this.memContactDDget();
                    this.ref_MemPauseType_List = this.localService.refMem_GetAllResponse.ref_MemPauseType_List;
                    this.ref_MemHardshipReason_List = this.localService.refMem_GetAllResponse.ref_MemHardshipReason_List;
                    this.ref_MemIndefiniteReason_List = this.localService.refMem_GetAllResponse.ref_MemIndefiniteReason_List;
                }
            }
        })
    }

    async CMClub_Get() {
        if (this.curTeam?.teamCode > 0) {
            this.showSpinner = true
            await this.clubService.CMClub_Get(this.encryptedUser, this.user?.cLPCompanyID, this.curTeam?.teamCode).
                then(async (result: CMClubResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.clubConfig = response?.clubConfig
                    }
                    this.showSpinner = false
                })
                .catch((err: HttpErrorResponse) => {
                    this.showSpinner = false
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }


    async siteSearch() {
        if (this.clubConfig?.clubId > 0) {
            await this.clubService.siteSearch(this.encryptedUser, 0, this.clubConfig?.clubId, 0, 0).
                then(async (result: CMSiteListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.sites = response?.sites;
                        this.sites.unshift({
                            siteID: 0,
                            clubID: 0,
                            class1Code: 0,
                            clpcompanyID: 0,
                            siteName: "--Select--",
                            teamCode: 0,
                            address: "",
                            city: "",
                            state: "",
                            country: "",
                            zip: "",
                            taxRate: 0,
                            scheduleSiteVisitURL: "",
                            scheduleOpenHouseURL: "",
                            vesselsURL: "",
                            kioskURL: "",
                            lnkCustom1URL: "",
                            lnkCustom2URL: "",
                            lnkCustom3URL: "",
                            lnkCustom4URL: "",
                            lnkCustom5URL: "",
                            mktCustomText1: "",
                            mktCustomText2: "",
                            mktCustomText3: "",
                            mktCustomText4: "",
                            mktCustomText5: "",
                            mktMultiText1: "",
                            mktMultiText2: "",
                            mktMultiText3: "",
                            mktMultiText4: "",
                            mktMultiText5: "",
                            engDashCustomMMT1D1: "",
                            engDashCustomMMT1D2: "",
                            engDashCustomMMT1D3: "",
                            engDashCustomMMT1D4: "",
                            engDashCustomMMT1D5: "",
                            engDashCustomMMT1D6: "",
                            engDashCustomMMT1D7: "",
                            engDashCustomMMT1D8: "",
                            engDashCustomMMT1D9: "",
                            engDashCustomMMT1D10: "",
                            dtCreated: "",
                            dtModified: "",
                            newLead: 0,
                            newMember: 0,
                            contractSent: 0,
                            contractOpen: 0,
                            waitingCountersign: 0,
                            memberAdded: 0,
                            contractUpgraded: 0,
                            contractRenewed: 0,
                            memberTerminated: 0,
                            contractExpiration: 0,
                            contactUpdate: 0,
                            referralRequest: 0,
                            teamCodeDisplay: "",
                            class1Display: "",
                            phLocation: "",
                            custom1: '',
                            custom2: '',
                            custom3: '',
                            contractCounts: 0
                        })
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private async authenticateR() {
        await this.localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    if (result?.strToken && result?.strToken != '') {
                        this.encryptedUser = result?.strToken;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    ngOnInit() {
        this.memPauseForm = this.prepareMemPauseForm();
    }

    prepareMemPauseForm() {
        return this.fb.group({
            pauseID: ['0'],
            pauseTypeID: ['0'],
            pauseStartDate: [''],
            pauseEndDate: [''],
            pauseAmount: ['0'],
            hardshipReasonID: ['0'],
            indefiniteReasonID: ['0'],
            contactId: [0]
        })
    }

    async memPause_Create() {
        let request: MemPause = <MemPause>{};
        request.clpCompanyID = this.user?.cLPCompanyID;
        request.clpUserID = this.user?.cLPUserID;
        request.contactID = +this.memPauseForm.controls.contactId.value;
        request.hardshipReasonID = +this.memPauseForm.controls.hardshipReasonID.value;
        request.indefiniteReasonID = +this.memPauseForm.controls.indefiniteReasonID.value;
        request.membershipIID = +this.memberShip.incrementalID;
        request.pauseAmount = +this.memPauseForm.controls.pauseAmount.value;
        request.pauseEndDate = this.memPauseForm.controls.pauseEndDate.value;
        request.pauseID = 0;
        request.pauseStartDate = this.memPauseForm.controls.pauseStartDate.value;
        request.pauseTypeID = +this.memPauseForm.controls.pauseTypeID.value;
        await this.membershipService.memPause_Create(this.encryptedUser, request)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.pauseID = response?.messageInt;
                    if (response?.messageBool) {
                        this._router.navigate(['/mem-pause'], { queryParams: { pauseID: this.pauseID } });
                        Swal.fire({ icon: "success", title: "", html: 'Successfully Created!.' });
                        return;
                    }
                    else {
                        Swal.fire({ icon: "error", title: "", html: 'Some error occurred, Try again.' });
                        return;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async memPause_Update() {
        let request: MemPause = <MemPause>{};
        request.clpCompanyID = this.user?.cLPCompanyID;
        request.clpUserID = this.user?.cLPUserID;
        request.contactID = +this.memPauseForm.controls.contactId.value;
        request.hardshipReasonID = +this.memPauseForm.controls.hardshipReasonID.value;
        request.indefiniteReasonID = +this.memPauseForm.controls.indefiniteReasonID.value;
        request.membershipIID = +this.memberShip?.incrementalID ? +this.memberShip?.incrementalID : this.memPause?.membershipIID ;
        request.pauseAmount = +this.memPauseForm.controls.pauseAmount.value;
        request.pauseEndDate = this.memPauseForm.controls.pauseEndDate.value;
        request.pauseID = +this.pauseID > 0 ? this.pauseID : this.memPause?.pauseID;
        request.pauseStartDate = this.memPauseForm.controls.pauseStartDate.value;
        request.pauseTypeID = +this.memPauseForm.controls.pauseTypeID.value;
        await this.membershipService.memPause_Update(this.encryptedUser, request)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response?.messageBool) {
                        Swal.fire({ icon: "success", title: "", html: 'Successfully update a Member Pause!.' });
                    }
                    else {
                        Swal.fire({ icon: "error", title: "", html: 'Some error occurred, Try again.' });
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async memPause_Get() {
        await this.membershipService.memPause_Get(this.encryptedUser, this.pauseID, this.contactId)
            .then(async (result: MemPause) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.memPause = response;
                    this.patchPauseForm();
                    await this.membership_GetByContactID_DDget();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    patchPauseForm() {
        this.memPauseForm.controls.pauseID.setValue(this.memPause.pauseID);
        this.memPauseForm.controls.pauseTypeID.setValue(this.memPause.pauseTypeID);
        this.memPauseForm.controls.pauseStartDate.setValue(this.memPause.pauseStartDate);
        this.memPauseForm.controls.pauseEndDate.setValue(this.memPause.pauseEndDate);
        this.memPauseForm.controls.pauseAmount.setValue(this.memPause.pauseAmount);
        this.memPauseForm.controls.hardshipReasonID.setValue(this.memPause.hardshipReasonID);
        this.memPauseForm.controls.indefiniteReasonID.setValue(this.memPause.indefiniteReasonID);
        this.memPauseForm.controls.contactId.setValue(this.memPause.contactID);
    }



    async memPause_Delete() {
        Swal.fire({
            title: '',
            text: "Are you sure, You wants to delete?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
        }).then(async (result) => {
            if (result.isConfirmed) {
                await this.membershipService.memPause_Delete(this.encryptedUser, this.pauseID)
                    .then(async (result: SimpleResponse) => {
                        if (result) {
                            let response = UtilityService.clone(result);
                            if (response?.messageBool) {
                                this._router.navigate(['/mem-pause-list']);
                            }
                            else {

                            }
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        this._globalService.error("mem-pause.memPause_Delete", err.message, null,
                        );
                        this._utilityService.handleErrorResponse(err);
                    });
            }
        });
    }

    async memContactDDget() {
        await this.membershipService.memContact_CMMember_GetList_DD(this.encryptedUser, this.user?.cLPCompanyID, this.user?.cLPUserID, this.clubConfig?.clubId)
            .then(async (result: MemContactListDropDown[]) => {
                if (result) {
                    this.memContact_dd = UtilityService.clone(result);
                    
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mem-pause.memContactDDget", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }


    async onChangeMemContact() {
        await this.membership_GetByContactID_DDget();
    }

    async membership_GetByContactID_DDget() {
        await this.membershipService.membership_GetByContactID(this.encryptedUser, +this.memPauseForm.controls.contactId.value)
            .then(async (result: Membership) => {
                if (result) {
                    this.memberShip = <Membership>{};
                    this.memberShip = UtilityService.clone(result);
                    if (isNullOrUndefined(this.memberShip)) {
                        Swal.fire({ icon: "error", title: "", html: 'The Contact is Not Subcribe!' });
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mem-pause.membership_GetByContactID_DDget", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }
}
